import { Injectable } from '@angular/core';
import { EmriBazaForCreationDTO } from '@core/interfaces/dto/emri-baza-for-creation-dto.interface';
import { EmriBazaForUpdateDTO } from '@core/interfaces/dto/emri-baza-for-update-dto.interface';
import { BazaForCreationDTO } from '../interfaces/dto/baza-for-creation-dto.interface';
import { BazaForUpdateDTO } from '../interfaces/dto/baza-for-update-dto.interface';
import { BazaParamsDTO } from '../interfaces/dto/baza-params-dto.interface';
import { Baza } from '../interfaces/models/baza.interface';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class BazaService {
  private baseUrl: string = 'baza';

  constructor(private apiService: ApiService) { }

  getBaza(params?: BazaParamsDTO) {
    return this.apiService.get<Baza[]>(`${this.baseUrl}/`, params);
  }

  getBazaById(id: number, params?: BazaParamsDTO) {
    return this.apiService.get<Baza>(`${this.baseUrl}/${id}`, params);
  }

  insertBaza(baza: BazaForCreationDTO) {
    return this.apiService.post<Baza>(`${this.baseUrl}`, baza);
  }

  updateBaza(baza: BazaForUpdateDTO) {
    return this.apiService.put<Baza>(`${this.baseUrl}`, baza);
  }

  deleteBaza(id: number) {
    return this.apiService.delete<boolean>(`${this.baseUrl}/${id}`);
  }
}
